import { render, staticRenderFns } from "./relatedOrder.vue?vue&type=template&id=57dc46ce&scoped=true"
import script from "./relatedOrder.vue?vue&type=script&lang=js"
export * from "./relatedOrder.vue?vue&type=script&lang=js"
import style0 from "./relatedOrder.vue?vue&type=style&index=0&id=57dc46ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57dc46ce",
  null
  
)

export default component.exports